import './AdditionalInformationHeroSection.scss';

const AdditionalInformationHeroSection = () => {
  return (
    <section className="__AdditionalInformationHeroSection d-flex flex-column align-items-center text-center justify-content-center position-relative">
      <div className="__my-container"></div>
    </section>
  );
};

export default AdditionalInformationHeroSection;
